import { useTranslation } from 'react-i18next'

import { Stack } from '@mui/material'

import { AsSeenInCarousel } from '@pages/LandingPage/components/AsSeenInCarousel'

import { TLGTypography } from '@components/TLGTypography'

import { containerSx } from './styles'

const AsSeenInSection = () => {
  const { t } = useTranslation()

  return (
    <Stack
      data-testid="tech-vendors-benefits-as-seen-in-section"
      sx={containerSx}
    >
      <TLGTypography responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}>
        {t('As seen in:')}
      </TLGTypography>

      <AsSeenInCarousel />
    </Stack>
  )
}

export { AsSeenInSection }
